import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import './MerchantNumbersList.scss';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';
import { Collapse } from 'react-collapse';

class MerchantNumbersList extends Component {
  constructor(props) {
    super(props);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.handleHeaderCheckChange = this.handleHeaderCheckChange.bind(this);
  }

  toggleCollapse(item) {
    this.props.toggleCollapse(item);
  }

  handleHeaderCheckChange = (item) => (e) => {
    item.selected = e.target.checked;
    this.props.handleHeaderCheckbox(item, this.props.filterName);
  }

  handleCheckChange = (item) => {
    this.props.handleChange(item, this.props.filterName);
    this.props.updateIsIndeterminate(this.props.dataList);
  }

  checkBrowser() {
    const ua = window.navigator.userAgent;
    const isIE = ua.indexOf('Trident/') || ua.indexOf('MSIE');
    return isIE;
  }

  resetScroll = () => {
    if(this.props.isMreFilterPaneVisible && this.props.isMreFilterPaneVisible === false) {
        const divElement = document.getElementById('resetScroll')
        divElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    } 
  }

  render() {
    this.resetScroll();
    const listWidth = this.checkBrowser() > 0 ? 369 : 325;
    const items = this.props.dataList && this.props.dataList?.map((item) => {
      return (
        <li className="reason-code-selection-list-item" role="menuitem" key={item.key} tabIndex={0}>
          <div className="item-header">
            <span className="mr-5" role="button" onClick={() => { this.toggleCollapse(item) }}> <ChevronDownIcon width='10' height='9' transform={item.isExpanded ? 'rotate(0)' : 'rotate(-90)'} /> </span>
            {this.props.elementId !== "cq_base_queue" &&
              <Checkbox
                indeterminate={item.isIndeterminate}
                onChange={this.handleHeaderCheckChange(item)}
                checked={item.selected}
                disabled={this.props.isViewFilter || this.props.isSelectAllButtonDisabled}
              >
              </Checkbox>
            }
            <div className="group" role="button" onClick={() => { this.toggleCollapse(item) }}>
              {item.key}
            </div>
            <div className="subtitle" role="button" onClick={() => { this.toggleCollapse(item) }}></div>
          </div>
          <Collapse isOpened={item.isExpanded}
            initialStyle={item.isExpanded
              ? { height: 'auto', overflow: 'initial' }
              : { height: '0px', overflow: 'hidden' }}
          >
            <div className="display-content">
              {item.items.map((child, index) => {
                const key = `${item.key}_${child.id}`
                if(index === 99) {
                  return (
                    this.props.isViewFilter ? child.selected && <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
  
                      </Checkbox>
                    </span> : this.props.currentMidCount > 0 ? <div><span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
  
                      </Checkbox>
                    </span>
                    <div className="vertical-nav-label" style={{fontSize:"10px", cursor: 'pointer'}}>{">>"}</div></div> : 
                    <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
  
                      </Checkbox>
                    </span>
                  )
                } else if(index === 0  && (this.props.filterName === "mre_merchant_numbers" || this.props.filterName === "mre_chain")) {
                  return (
                    this.props.isViewFilter ? child.selected && <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
                      </Checkbox>
                    </span> : this.props.midPage > 0 ? <div>
                    <div className="vertical-nav-label" style={{fontSize:"10px", cursor: 'pointer'}}>{"<<"}  <span style={{marginLeft: "auto"}}>{this.props.pageLabel} {this.props.midPage + 1} {this.props.ofLabel} {this.props.filterName == "mre_chain" ? this.props.totalChainPages : this.props.totalMidPages}</span></div>
                      <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
                      </Checkbox>
                    </span></div> : <div><div className="vertical-nav-label" style={{fontSize:"10px"}}><span style={{marginLeft: "auto"}}>{this.props.pageLabel} {this.props.midPage + 1} {this.props.ofLabel} {this.props.filterName == "mre_chain" ? this.props.totalChainPages : this.props.totalMidPages}</span></div><span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
                      </Checkbox>
                    </span></div>
                  )
                } else {
                  return (
                    this.props.isViewFilter ? child.selected && <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
  
                      </Checkbox>
                    </span> : <span id="label" key={key} className="vertical-nav-label">
                      <Checkbox disabled={child.isRuleCreated == "true" ? true : this.props.isViewFilter ? true : false} onChange={() => { this.handleCheckChange(child); }}
                        checked={child.selected} >
                        {child.text}
  
                      </Checkbox>
                    </span>
                  )
                }
              })}
            </div>
          </Collapse>
        </li>
      );
    });



    return (
      <Collapse
        id={this.props.filterName}
        style={{ width: listWidth }}

        className="list-rc">
        <div className={classNames('reason-code-selection-list', {
          'group-search-open': this.props.visible
        })}>
          <ol id='resetScroll' className="reason-code-selection-list-items">
            {items}
          </ol>
        </div>
      </Collapse>
    )
  }

};

MerchantNumbersList.propTypes = {
  dataList: PropTypes.array.isRequired,
  extraClass: PropTypes.string,
  visible: PropTypes.bool,
  searchTerm: PropTypes.string,
  handleChange: PropTypes.func,
  handleHeaderCheckbox: PropTypes.func,
  toggleCollapse: PropTypes.func
};

MerchantNumbersList.defaultProps = {
  extraClass: '',
  searchTerm: '',
  dataList: [],
  isSelectAllButtonDisabled : false
};

export default MerchantNumbersList;
